import React,{ useEffect } from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import SendIcon from '@mui/icons-material/Send';
import UploadImg from './UploadImg';

export default function MessageBar (){
	return(
		<>
			<article className="message-bar">
				<UploadImg />
				
				<TextareaAutosize
				aria-label="minimum height"
				maxsRows={4}
				placeholder="heyaaa!"
				style={{ width: '75%', padding: 15 }}
				/>
				<SendIcon onClick={""}/>
			</article>
		</>
	);
}